import PropTypes from 'prop-types';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import PersonIcon from '@mui/icons-material/Person';
import { useLocation, useNavigate } from 'react-router';
import { menuItemClasses } from '@mui/material';
import SecurityIcon from '@mui/icons-material/Security';

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

export default function ProfileTab({ close }) {
  const navigate = useNavigate();
  const { pathname } = useLocation(); // to find the current pathname 
  const location = useLocation();
  const tab = location.state?.tab;
  console.log(tab)

  return (
    <List component="nav" sx={{
      p: 1,
      '& .MuiListItemIcon-root': { minWidth: 32 },
      [`&.${menuItemClasses.selected}`]: {
        color: 'text.primary',
        bgcolor: 'action.selected',
        fontWeight: 'fontWeightSemiBold',
      },
    }}>
      <ListItemButton
        onClick={() => {
          navigate("/profile", { state: { tab: "profile" } })

          close()
        }}
        sx={{ borderRadius: "5px" }}
        selected={tab == "profile"}
      >
        <ListItemIcon>
          <PersonIcon />
        </ListItemIcon>
        <ListItemText primary="Profile" color='#000' />
      </ListItemButton>
      <ListItemButton
        onClick={() => {
          navigate("/profile", { state: { tab: "password" } })
          close()
        }}
        sx={{ borderRadius: "5px" }}
        selected={tab == "password"}
      >
        <ListItemIcon>
          <SecurityIcon />
        </ListItemIcon>
        <ListItemText primary="Change Password" color='#000' />
      </ListItemButton>
    </List>
  );
}

ProfileTab.propTypes = { handleLogout: PropTypes.func };
